import { ErrorApi, Preloader, SelectOption, Title } from 'src/components'
import { LogLevel } from '../api'
import { useChangeLogLevel, useGetLogLevel } from '../queries'
import SelectWithLabel from 'src/components/Shared/UIComponents/Select'

export default function AdminLogLevel() {
  return (
    <>
      <Title label="Log Level" className="mb-8" />
      <AdminLogLevelContent />
    </>
  )
}

function AdminLogLevelContent() {
  const logLevel = useGetLogLevel()
  const changeLogLevel = useChangeLogLevel()

  if (logLevel.status === 'loading' || logLevel.status === 'idle') {
    return <Preloader className="col-span-full" />
  }

  if (logLevel.status === 'error') {
    return (
      <div className="col-span-full">
        <ErrorApi message={logLevel.error} onClick={logLevel.refetch} />
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 gap-6">
      {Object.entries(logLevel.data).map((item) => (
        <SelectWithLabel
          key={item[0]}
          options={logLevelOptions}
          onChange={(value) => {
            if (value) {
              changeLogLevel.mutate({ server: item[0], loglevel: value })
            }
          }}
          title={item[0]}
          value={item[1]}
          disabled={item[1] === null}
          placeholder={item[1] === null ? 'Not running' : undefined}
        />
      ))}
    </div>
  )
}

const logLevelOptions: SelectOption<LogLevel>[] = [
  { key: 'info', name: 'Info' },
  { key: 'debug', name: 'Debug' },
  { key: 'error', name: 'Error' },
]
